// Kept apart so tests can replace the one call that leaves the page.
export function redirectTo(url) {
  window.location.replace(url);
}
